import React, { FC } from 'react';

export const CrashMessageHeader: FC = ({ children }) => (
  <div className="crash__header">
    <h2 className="crash__title">{children}</h2>
  </div>
);
